import React from "react";

const LucyGold = props => (
  <svg id="svg1" width={960} height={768} viewBox="0 0 960 768" {...props}>
    <defs id="defs1">
      <colorProfile name="sRGB IEC61966-2.1" id="color-profile1" />
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath28">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-252.00008,-82.7998)"
          id="path28"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath30">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-468.00009,-504.00001)"
          id="path30"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath32">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-358.77908,-410.93601)"
          id="path32"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath34">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-328.73708,-300.08621)"
          id="path34"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath36">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-422.84911,-205.73071)"
          id="path36"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath38">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-282.53761,-205.73071)"
          id="path38"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath40">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-397.47128,-157.95081)"
          id="path40"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath42">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-227.23471,-205.46721)"
          id="path42"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath44">
        <path d="M 0,576 H 720 V 0 H 0 Z" id="path44" />
      </clipPath>
    </defs>
    <g id="layer-MC0" transform="translate(-980)">
      <path
        id="path27"
        d="m 0,0 c -113.147,0 -205.2,92.053 -205.2,205.2 0,113.148 92.053,205.2 205.2,205.2 h 216 c 113.147,0 205.2,-92.052 205.2,-205.2 C 421.2,92.053 329.147,0 216,0 Z"
        style={{
          fill: "#ffffff",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,1316.0001,657.60027)"
        clipPath="url(#clipPath28)"
      />
      <path
        id="path29"
        d="m 0,0 h -216 c -119.293,0 -216,-96.707 -216,-216 0,-119.293 96.707,-216 216,-216 H 0 c 119.293,0 216,96.707 216,216 C 216,-96.707 119.293,0 0,0 m 0,-21.6 c 51.926,0 100.744,-20.221 137.461,-56.939 36.718,-36.717 56.939,-85.535 56.939,-137.461 0,-51.926 -20.221,-100.744 -56.939,-137.461 C 100.744,-390.179 51.926,-410.4 0,-410.4 h -216 c -51.926,0 -100.745,20.221 -137.461,56.939 -36.718,36.717 -56.939,85.535 -56.939,137.461 0,51.926 20.221,100.744 56.939,137.461 36.716,36.718 85.535,56.939 137.461,56.939 z"
        style={{
          fill: "#f8d20f",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,1604.0001,96)"
        clipPath="url(#clipPath30)"
      />
      <path
        id="path31"
        d="m 0,0 c 12.467,6.356 24.781,13.036 37.427,19.013 53.718,25.384 111.737,-12.349 123.935,-62.616 14.159,-58.35 -31.63,-116.799 -91.497,-114.713 -25.559,0.891 -47.138,13.896 -68.242,27.099 10.182,6.696 20.365,13.392 30.547,20.087 11.851,-6.876 23.888,-13.66 37.933,-14.253 29.671,-1.252 56.024,21.379 60.495,51.392 4.315,28.962 -14.716,57.817 -43.004,66.145 -20.866,6.143 -38.138,-2.46 -55.357,-12.105 -10.719,-5.515 -21.19,-11.425 -30.527,-19.144 -12.968,-7.493 -24.498,-16.953 -37.247,-26.571 12.321,-9.151 23.98,-17.811 35.638,-26.47 -9.213,-7.582 -19.382,-13.624 -30.143,-18.714 -11.837,9.091 -23.809,18.013 -35.48,27.311 -16.93,13.488 -16.836,22.408 0.288,36.124 11.624,9.311 23.477,18.336 35.227,27.489 C -20.004,-13.284 -10.002,-6.642 0,0"
        style={{
          fill: "#f7d808",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,1458.3721,220.08533)"
        clipPath="url(#clipPath32)"
      />
      <path
        id="path33"
        d="m 0,0 c 10.761,5.09 20.93,11.132 30.143,18.714 11.477,6.154 21.2,14.822 31.856,22.149 5.319,3.657 3.967,6.043 -0.426,9.151 C 51.531,57.117 41.68,64.491 31.752,71.755 41.089,79.474 51.56,85.384 62.281,90.9 74.986,80.798 87.835,70.872 100.349,60.54 112.878,50.194 112.863,40.318 100.344,30.043 87.792,19.742 74.935,9.813 62.212,-0.28 52.03,-6.976 41.847,-13.671 31.665,-20.367 18.241,-27 5.252,-34.413 -8.499,-40.501 c -56.145,-24.857 -121.927,21.139 -122.952,81.671 -0.849,50.125 31.079,88.295 80.506,96.196 13.682,2.187 26.63,-0.583 39.292,-5.241 C 3.074,126.706 17.009,119.638 30.041,110.85 20.04,104.208 10.038,97.565 0.036,90.924 c -6.095,3.075 -12.026,6.546 -18.314,9.155 -26.49,10.993 -54.335,2.643 -70.554,-20.887 -15.921,-23.097 -13.527,-54.57 5.686,-74.735 C -60.516,-19.296 -31.649,-20.844 0,0"
        style={{
          fill: "#048945",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,1418.3161,367.88507)"
        clipPath="url(#clipPath34)"
      />
      <path
        id="path35"
        d="m 0,0 c 0,4.237 0.232,8.49 -0.055,12.707 -0.424,6.238 1.146,9.56 8.487,9.469 6.903,-0.086 8.119,-3.228 7.996,-9.03 -0.185,-8.794 -0.032,-17.606 0.314,-26.397 0.425,-10.789 7.77,-18.311 17.575,-18.44 9.92,-0.131 17.794,7.075 18.417,17.64 0.556,9.427 0.642,18.905 0.395,28.346 -0.159,6.112 2.42,7.919 8.151,7.804 5.341,-0.108 8.697,-1.032 8.384,-7.533 C 69.21,5.132 69.838,-4.36 69.258,-13.781 67.988,-34.376 53.439,-47.974 33.675,-47.597 14.837,-47.238 0.828,-32.727 0.089,-12.711 -0.068,-8.48 0.066,-4.237 0.066,0 0.044,0 0.022,0 0,0"
        style={{
          fill: "#048945",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,1543.7988,493.6924)"
        clipPath="url(#clipPath36)"
      />
      <path
        id="path37"
        d="m 0,0 c 0,4.237 0.232,8.49 -0.055,12.707 -0.424,6.238 1.146,9.56 8.487,9.469 6.903,-0.086 8.119,-3.228 7.996,-9.03 -0.185,-8.794 -0.032,-17.606 0.314,-26.397 0.425,-10.789 7.77,-18.311 17.575,-18.44 9.92,-0.131 17.794,7.075 18.417,17.64 0.556,9.427 0.642,18.905 0.395,28.346 -0.159,6.112 2.42,7.919 8.151,7.804 5.341,-0.108 8.697,-1.032 8.384,-7.533 C 69.21,5.132 69.838,-4.36 69.258,-13.781 67.988,-34.376 53.439,-47.974 33.675,-47.597 14.837,-47.238 0.828,-32.727 0.089,-12.711 -0.068,-8.48 0.066,-4.237 0.066,0 0.044,0 0.022,0 0,0"
        style={{
          fill: "#048945",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,1356.7168,493.6924)"
        clipPath="url(#clipPath38)"
      />
      <path
        id="path39"
        d="m 0,0 c -14.66,-0.802 -26.03,5.655 -32.827,19.214 -6.419,12.807 -4.9,25.359 3.602,36.844 9.79,13.225 23.988,14.395 38.766,13.56 6.251,-0.353 4.455,-5.269 4.646,-8.847 0.199,-3.718 0.077,-7.439 -5.283,-7.36 -3.587,0.054 -7.186,0.08 -10.763,-0.148 -10.775,-0.689 -17.989,-7.855 -18.215,-17.928 -0.239,-10.716 6.912,-18.447 17.913,-19.27 2.272,-0.17 4.577,-0.222 6.846,-0.054 5.902,0.438 9.799,-0.339 9.806,-8.084 0.007,-7.912 -4.21,-8.323 -9.943,-7.94 C 3.249,0.074 1.939,0 0,0"
        style={{
          fill: "#048945",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,1509.9617,557.39893)"
        clipPath="url(#clipPath40)"
      />
      <path
        id="path41"
        d="m 0,0 c 0.001,4.239 0.17,8.486 -0.041,12.715 -0.273,5.461 0.227,9.262 7.519,9.363 7.679,0.106 8.404,-3.778 8.222,-9.747 -0.22,-7.164 0.052,-14.345 0.208,-21.517 0.342,-15.773 7.027,-22 22.956,-22.609 4.06,-0.155 10.574,3.522 11.786,-4.482 1.045,-6.895 0.251,-11.372 -9.164,-11.382 C 11.068,-47.688 -0.048,-35.382 0,0"
        style={{
          fill: "#048945",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,1282.9796,494.04373)"
        clipPath="url(#clipPath42)"
      />
      <path
        id="path43"
        d="m 466.819,159.298 h -17.546 v -21.51 h 17.546 z"
        style={{
          fill: "#048945",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,980,768)"
        clipPath="url(#clipPath44)"
      />
    </g>
    <g
      id="layer-MC1"
      style={{
        display: "none"
      }}
      transform="translate(-980)"
    />
  </svg>
);
export default LucyGold;
